import { createBrowserRouter, Outlet } from "react-router-dom";

import LoginComponent from "./pages/Login/LoginPage";
import { routes } from "./routes";
import NotFound from "./components/NotFound";

import { FilterPage } from "src/routes/companyId/FilterComponent";
import { InspectionMap } from "src/routes/companyId/Map/Map";
import { RedirectPage } from "./pages/Login/Redirect";
import { InspectionLayout } from "./components/Layout/Egenkontroll/EgenkontrollerLayout";
import NavigatedLayout from "./components/Layout/Egenkontroll/NavigatedToPage";
import { ListEgenkontroller } from "./pages/Egenkontroller/List";
import { ShowEgenkontroller } from "./pages/Egenkontroller/Show";
import { EditInspection } from "./pages/Egenkontroller/EditEgenkontroll";
import { ShowInspectionDeviationById } from "./pages/Egenkontroller/Deviations/ShowById";
import { ListDeviations } from "./pages/Egenkontroller/Deviations/List";
import { CreateDeviation } from "./pages/Egenkontroller/Deviations/CreateDeviation";
import { EditInspectionDeviation } from "./pages/Egenkontroller/Deviations/EditDeviation";
import { EditDeviation } from "./pages/Deviations/EditDeviation";
import { ShowDeviationById } from "./pages/Deviations/ShowById";
import CreateEgenkontroll from "./pages/Egenkontroller/CreateEgenkontroll";
import CreateDeviationWithoutParent from "src/pages/Deviations/CreateDeviation";
import { ShowAssignments } from "./pages/Egenkontroller/Assignments/Assignments";
import { DeviationsList } from "src/pages/Deviations/List";
import { GroupsPage } from "./pages/GroupsPage";
import { UsersPage } from "./pages/UsersPage";
import { CompanyPage } from "./pages/CompanyPage";
import { DocumentsList } from "./components/DocumentsList";
import { PlannerPage } from "./pages/Planner/PlannerPage";
import { StartPage } from "./pages/StartPage";
import { ActiveSchemas } from "./pages/VehicleInspection/ActiveSchemas";
import { SchemaForm } from "./pages/VehicleInspection/SchemaForm";
import { ShowFormResult } from "./pages/VehicleInspection/ShowFormResult";
import { ReportPage } from "./routes/companyId/ReportPage";
import { SignOut } from './routes/SignOut'

export const router = createBrowserRouter([
  {
    element: <Outlet />,
    children: [
      {
        path: routes.SignOut.path,
        element: <SignOut />,
      },
      {
        element: <InspectionLayout />,
        children: [
          {
            path: routes.Report.path,
            element: <ReportPage />,
          },
          {
            path: routes.Egenkontroller.Pages.List.path,
            element: <ListEgenkontroller />,
          },
          {
            path: routes.Egenkontroller.Pages.ListWithInspectionId.path,
            element: <ListEgenkontroller />,
          },
          {
            path: routes.Egenkontroller.Pages.Create.path,
            element: <CreateEgenkontroll />,
          },
          {
            path: routes.Egenkontroller.Pages.Show.path,
            element: <ShowEgenkontroller />,
          },

          {
            path: routes.Egenkontroller.Pages.Map.path,
            element: <InspectionMap />,
          },
          {
            path: routes.Egenkontroller.Pages.MapByInspectionId.path,
            element: <InspectionMap />,
          },
          {
            path: routes.Egenkontroller.Pages.MapByDeviationId.path,
            element: <InspectionMap />,
          },
          {
            path: routes.Deviation.Pages.List.path,
            element: <DeviationsList />,
          },
          {
            path: routes.Deviation.Pages.List.path,
            element: <DeviationsList />,
          },
          {
            path: routes.Deviation.Pages.Create.path,
            element: <CreateDeviationWithoutParent />,
          },
          {
            path: routes.Deviation.Pages.Show.path,
            element: <ShowDeviationById />,
          },
          {
            path: routes.Start.path,
            element: <StartPage />,
          },
          {
            element: <DocumentsList />,
            path: routes.SigningSession.Documents.path,
          },
          {
            path: routes.Egenkontroller.Pages.Edit.path,
            element: <EditInspection />,
          },
        ],
      },
      {
        element: <NavigatedLayout />,
        children: [
          {
            path: routes.Planner.path,
            element: <PlannerPage />,
          },
          {
            path: routes.Users.path,
            element: <UsersPage />,
          },
          {
            path: routes.Groups.manage.path,
            element: <GroupsPage />,
          },
          {
            path: routes.Company.manage.path,
            element: <CompanyPage />,
          },
          
          {
            path: routes.Filter.path,
            element: <FilterPage />,
          },

          {
            element: <DocumentsList />,
            path: routes.SigningSession.DocumentById.path,
          },
          {
            element: <DocumentsList />,
            path: routes.SigningSession.Sign.path,
          },
          {
            path: routes.Egenkontroller.Pages.Deviations.Edit.path,
            element: <EditInspectionDeviation />,
          },
          {
            path: routes.Egenkontroller.Pages.Deviations.ShowById.path,
            element: <ShowInspectionDeviationById />,
          },
          {
            path: routes.Egenkontroller.Pages.Deviations.List.path,
            element: <ListDeviations />,
          },
          {
            path: routes.Egenkontroller.Pages.Deviations.Create.path,
            element: <CreateDeviation />,
          },
          {
            path: routes.Deviation.Pages.Edit.path,
            element: <EditDeviation />,
          },
          {
            path: routes.Assignments.show.path,
            element: <ShowAssignments />,
          },
          {
            path: routes.VehicleInspection.ActiveSchemas.path,
            element: <ActiveSchemas />,
          },
        ],
      },
      {
        path: routes.VehicleInspection.Form.path,
        element: <SchemaForm />,
      },
      {
        path: routes.VehicleInspection.ShowFormResult.path,
        element: <ShowFormResult />,
      },
      { path: routes.Login.path, element: <LoginComponent /> },
      { path: routes.Redirect.path, element: <RedirectPage /> },
      { path: routes.RedirectToLogin.path, element: <RedirectPage /> },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);
